export type Attribution = {
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmContent: string | null;
  flowdContactId: string | null;
  landingVariant: string | null;
  firstTouchAt: string;
};

const MAX_LENGTH = 200;
// oxlint-disable-next-line no-control-regex -- stripping control characters from untrusted URL input is the point
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/g;

function clean(value: string | null): string | null {
  if (value == null) return null;
  const trimmed = value.replace(CONTROL_CHARACTERS, '').trim().slice(0, MAX_LENGTH);
  return trimmed === '' ? null : trimmed;
}

/** First-touch attribution from the landing URL. Flowd links carry `contact_id`. */
export function attributionFromSearch(search: string, now: Date): Attribution {
  const params = new URLSearchParams(search);
  return {
    utmSource: clean(params.get('utm_source')),
    utmMedium: clean(params.get('utm_medium')),
    utmCampaign: clean(params.get('utm_campaign')),
    utmContent: clean(params.get('utm_content')),
    flowdContactId: clean(params.get('flowd_contact_id') ?? params.get('contact_id')),
    landingVariant: clean(params.get('variant')),
    firstTouchAt: now.toISOString(),
  };
}

export function sanitiseAttribution(input: Attribution): Attribution {
  return {
    utmSource: clean(input.utmSource),
    utmMedium: clean(input.utmMedium),
    utmCampaign: clean(input.utmCampaign),
    utmContent: clean(input.utmContent),
    flowdContactId: clean(input.flowdContactId),
    landingVariant: clean(input.landingVariant),
    firstTouchAt: input.firstTouchAt,
  };
}

/** HubSpot's compressed `fhp_campaign_source`. Derived at sync time, never stored as canonical. */
export function campaignSourceString(attribution: Pick<Attribution, 'utmSource' | 'utmMedium' | 'utmCampaign' | 'utmContent'>): string {
  const parts = [attribution.utmSource, attribution.utmMedium, attribution.utmCampaign, attribution.utmContent];
  if (parts.every((part) => part == null)) return '';
  return parts.map((part) => part ?? '').join('/');
}
